import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { CareLinksActions } from './care-links.actions';
import { InviteCaregiverRequest } from '@app/core/api/care-links';
import {
  selectCaregivers,
  selectActiveCaregivers,
  selectPendingCaregivers,
  selectCareLinksLoading,
  selectCareLinksInviting,
  selectCareLinksError,
} from './care-links.selectors';

@Injectable({ providedIn: 'root' })
export class CareLinksFacade {
  private readonly store = inject(Store);

  readonly caregivers$ = this.store.select(selectCaregivers);
  readonly activeCaregivers$ = this.store.select(selectActiveCaregivers);
  readonly pendingCaregivers$ = this.store.select(selectPendingCaregivers);
  readonly loading$ = this.store.select(selectCareLinksLoading);
  readonly inviting$ = this.store.select(selectCareLinksInviting);
  readonly error$ = this.store.select(selectCareLinksError);

  loadCaregivers(): void {
    this.store.dispatch(CareLinksActions.loadCaregivers());
  }

  inviteCaregiver(request: InviteCaregiverRequest): void {
    this.store.dispatch(CareLinksActions.inviteCaregiver({ request }));
  }

  revokeLink(linkId: string): void {
    this.store.dispatch(CareLinksActions.revokeLink({ linkId }));
  }

  resendInvitation(linkId: string): void {
    this.store.dispatch(CareLinksActions.resendInvitation({ linkId }));
  }

  clearState(): void {
    this.store.dispatch(CareLinksActions.clearCareLinksState());
  }

  clearError(): void {
    this.store.dispatch(CareLinksActions.clearError());
  }
}
